// extracted by mini-css-extract-plugin
export default {"international__organizations":"InternationalOrganizations_international__organizations__FoAKg"};